module.exports = __webpack_public_path__ + "img/b3.f7a8e219.png";